// extracted by mini-css-extract-plugin
export default {"list":"List_list__QHpVn","listItem":"List_listItem__VKJ50"};